import React from 'react';
import { motion } from 'framer-motion';
import { Hand, Flower2, Droplets, Sparkles, ArrowRight } from 'lucide-react';
const services = [{
  icon: Hand,
  title: '传统中式推拿',
  enTitle: 'Traditional Chinese Tuina',
  desc: '传承千年的经络穴位按摩，有效缓解肌肉酸痛，疏通经络，恢复身体活力。',
  color: 'bg-[#F5EDE0]'
}, {
  icon: Flower2,
  title: '泰式按摩',
  enTitle: 'Thai Massage',
  desc: '结合瑜伽拉伸与穴位按压，增强身体柔韧性，释放深层压力，平衡身心。',
  color: 'bg-[#FDF8F0]'
}, {
  icon: Droplets,
  title: '精油SPA',
  enTitle: 'Essential Oil SPA',
  desc: '选用顶级天然植物精油，配合舒缓手法，滋养肌肤，安神助眠，奢华享受。',
  color: 'bg-[#F5EDE0]'
}, {
  icon: Sparkles,
  title: '特色理疗',
  enTitle: 'Specialty Therapy',
  desc: '针对性解决肩颈腰腿痛等亚健康问题，结合拔罐、刮痧等传统技法。',
  color: 'bg-[#FDF8F0]'
}];
export function ServicesSection() {
  return <section id="services" className="py-24 bg-white" data-id="element-256">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-257">
        <div className="text-center mb-16" data-id="element-258">
          <motion.span initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} className="text-[#C9A96E] font-medium tracking-widest uppercase text-sm" data-id="element-259">
            Our Services
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-[#2D5A3D] mt-2 mb-4" data-id="element-260">
            精选专业按摩服务
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-[#666] max-w-2xl mx-auto" data-id="element-261">
            无论您寻找深层放松还是治疗性按摩，我们都能为您匹配最适合的专业体验。
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-262">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -10
        }} className={`group p-8 rounded-2xl ${service.color} hover:shadow-xl transition-all duration-300 border border-[#D4B483]/10`} data-id="element-263">
              <div className="w-14 h-14 bg-[#2D5A3D] rounded-full flex items-center justify-center mb-6 group-hover:bg-[#C9A96E] transition-colors duration-300" data-id="element-264">
                <service.icon className="w-7 h-7 text-white" data-id="element-265" />
              </div>
              <h3 className="text-xl font-bold text-[#1A1A1A] mb-1" data-id="element-266">
                {service.title}
              </h3>
              <p className="text-xs text-[#C9A96E] font-medium uppercase tracking-wide mb-4" data-id="element-267">
                {service.enTitle}
              </p>
              <p className="text-[#666] text-sm leading-relaxed mb-6" data-id="element-268">
                {service.desc}
              </p>
              <a href="#" className="inline-flex items-center text-[#2D5A3D] font-medium text-sm group-hover:text-[#C9A96E] transition-colors" data-id="element-269">
                了解详情 <ArrowRight className="w-4 h-4 ml-1" data-id="element-270" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}